import emojis from 'emojilib';

import unionBy from 'lodash/unionBy';
import dataByEmoji from 'unicode-emoji-json/data-by-emoji.json';

import {storage} from '@edna/utils';

import AppleIcon from './icons/apple.svg';
import BallIcon from './icons/ball.svg';
import CarIcon from './icons/car.svg';
import DogIcon from './icons/dog.svg';
import FlagIcon from './icons/flag.svg';
import LampIcon from './icons/lamp.svg';
import PeopleIcon from './icons/people.svg';
import SmileIcon from './icons/smile.svg';
import SymbolIcon from './icons/symbol.svg';
import TimeIcon from './icons/time.svg';
import {EGroup, TEmoji, TEmojiLib} from './types';

export const MAX_RECENT_EMOJI_COUNT = 36;

export const GROUPS = Object.values(EGroup);

export const ALL_EMOJIS: TEmoji[] = Object.entries(emojis).map(([char, keywords]) => {
  const data = (dataByEmoji as Record<string, TEmojiLib>)[char];

  return {
    keywords,
    char,
    name: data?.name,
    group: data?.group,
  };
});

export const getRecent = (): TEmoji[] =>
  unionBy((storage.get('emoji.recent', true) ?? []) as TEmoji[], 'name');

export const updateRecent = (nextEmojis: TEmoji[]): void =>
  storage.set('emoji.recent', nextEmojis.slice(0, MAX_RECENT_EMOJI_COUNT), true);

export const getEmojiGroupHash = () =>
  ALL_EMOJIS.reduce(
    (result, emoji) => ({
      ...result,
      [emoji.group]: [...(result[emoji.group] ?? []), emoji],
    }),
    {[EGroup.recent]: getRecent()} as Record<EGroup, TEmoji[]>,
  );

export const groupIconHash: Record<EGroup, TAnyComponent> = {
  [EGroup.recent]: TimeIcon,
  [EGroup.people]: PeopleIcon,
  [EGroup.smileys]: SmileIcon,
  [EGroup.animals_and_nature]: DogIcon,
  [EGroup.food_and_drink]: AppleIcon,
  [EGroup.activity]: BallIcon,
  [EGroup.travel_and_places]: CarIcon,
  [EGroup.objects]: LampIcon,
  [EGroup.symbols]: SymbolIcon,
  [EGroup.flags]: FlagIcon,
};
